import { render, staticRenderFns } from "./BaseArticleInterviewRow.vue?vue&type=template&id=0fec460f&scoped=true&"
import script from "./BaseArticleInterviewRow.vue?vue&type=script&lang=js&"
export * from "./BaseArticleInterviewRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseArticleInterviewRow.vue?vue&type=style&index=0&id=0fec460f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec460f",
  null
  
)

export default component.exports